import {Presenter} from '../support/with_presenter';
import {DragContext, Draggables} from '../../business/drag_context';
import {SprintDeleter} from '../../business/sprint_deleter';
import * as React from 'react';
import {SprintSelectionManager} from '../../business/sprint_selection_manager';
import {first} from 'rxjs/operators';

export class DestroyButtonPresenter implements Presenter {
    constructor(
        private dragContext: DragContext,
        private sprintDeleter: SprintDeleter,
        private sprintSelectionManager: SprintSelectionManager,
    ) {}

    public mount(): void {
        document.getElementsByTagName('body')[0].addEventListener('keydown', (e) => {
            if (e.key === 'Delete') {
                this.handleOnClick();
            }
        });
    }

    public unmount(): void {
        /* Noop */
    }

    public async handleDrop() {
        if (
            this.dragContext.currentlyDragged !== null &&
            this.dragContext.currentlyDragged.type === Draggables.Sprint
        ) {
            const sprintId = this.dragContext.currentlyDragged.id;
            this.dragContext.clear();
            await this.sprintDeleter.destroy(sprintId);
        }
    }

    public handleDragOver(event: React.DragEvent<HTMLSpanElement>) {
        if (
            this.dragContext.currentlyDragged !== null &&
            this.dragContext.currentlyDragged.type === Draggables.Sprint
        ) {
            event.preventDefault();
        }
    }

    public async handleOnClick() {
        const sprintIds = await this.sprintSelectionManager.selection.pipe(first()).toPromise();
        await this.sprintDeleter.destroyMany(sprintIds);
        this.sprintSelectionManager.clear();
    }
}
